import React from "react";
import "../OurServices.css";
import OurServicesBox from "./serviceBoxes";
import arImg from "../Images/ar.gif";
import unity from "../Images/unity.gif";
import userManual from "../Images/manual.gif";

function OurServices() {
  return (
    <div id="services">
      <p>What We Offer</p>
      <div className="a-container">
        <OurServicesBox
          image={arImg}
          title="Augmented Reality"
          description="Efficient apps developed on Unity Engine provide seamless and easy-to-use functionalities."
        />
        <OurServicesBox
          image={unity}
          title="Unity Mobile App"
          description="Efficient apps developed on Unity Engine provide seamless and easy-to-use functionalities."
        />
        <OurServicesBox
          image={userManual}
          title="AR User Manuals"
          description="Efficient apps developed on Unity Engine provide seamless and easy-to-use functionalities."
        />
      </div>
      <a className="moreServices"href="/services">See More</a>
    </div>
  );
}

export default OurServices;
